/* eslint-disable no-console */
import React from 'react';
import {
  Pie,
  ResponsiveContainer,
  PieChart as PieReChart,
  Cell,
  Legend
} from 'recharts';

import {pairsOfColour} from '../../../pages/netZero/constants/commonConstants';
import {PieChartStyle} from '../RadialChart/constants/common';
import RadialCustomizedLegend from '../RadialChart/utils/RadialCustomizedLegend';

import renderCustomizedLabel from './utils/RenderCustomLabelSingle';

const PieChart: React.FC<{
  data: any[];
  showLegend?: boolean;
  showLabel?: boolean;
  noStrokeWidth?: boolean;
}> = ({data, showLabel = true, showLegend = true, noStrokeWidth = false}) => {
  const colorPair =
    pairsOfColour[Math.floor(Math.random() * pairsOfColour.length)];

  if (
    data?.every((item: any) => {
      return item?.value === 0 || typeof item?.value !== 'number';
    })
  ) {
    data = [{value: 100, fill: '#E0EFFD'}];
  }

  return (
    <ResponsiveContainer width="100%" height="100%" style={{flex: 1}}>
      <PieReChart width={500} height={500} style={{padding: '2%'}}>
        <Pie
          data={data}
          cx={showLabel ? '30%' : '50%'}
          outerRadius={'80%'}
          labelLine={false}
          label={showLabel ? renderCustomizedLabel : undefined}
          fill="#8884d8"
          dataKey="value"
          minAngle={5}
        >
          {data.map((entry, index) => (
            <Cell
              style={{outline: 'none'}}
              key={`cell-${index}`}
              fill={entry.fill ?? colorPair[index]}
              strokeWidth={noStrokeWidth ? 0 : 2}
            />
          ))}
        </Pie>
        {showLegend && (
          <Legend
            iconSize={7}
            layout="vertical"
            verticalAlign="middle"
            wrapperStyle={PieChartStyle}
            iconType="circle"
            content={<RadialCustomizedLegend data={data} />}
          />
        )}
      </PieReChart>
    </ResponsiveContainer>
  );
};

export default PieChart;
